// extracted by mini-css-extract-plugin
module.exports = {"diagram__container":"WorkflowDefinitionPreview_diagram__container__2N6DI"};